import { FaShareAlt } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import useCustomNavigate from "../../../../../hooks/useCustomNavigate";
import { useParams } from "react-router-dom";

const FlatListingHeader = () => {
  const {goTo} = useCustomNavigate()
  const {propertyId} = useParams()
  return (
    <div className="px-4 bg-black text-white">
      <div className="flex items-center justify-between px-4 pb-3">
        <div className="flex items-center gap-2">
          <IoClose className="text-[24px] cursor-pointer" onClick={()=>{goTo(`/propertydetail/${propertyId}`)}}  />
          <h2 className="text-lg font-semibold">
            2 BHK Flat For Sale in Elegant Param, in Gandhi Path, Jaipur
          </h2>
        </div>
        <div className="flex items-center gap-4">
          <FaShareAlt className="text-xl cursor-pointer" />
          <button className="bg-red-600 text-white px-4 py-2 rounded-full font-semibold">
            Contact Owner
          </button>
        </div>
      </div>
      
      <div className="flex gap-6 px-4 py-2 border-b border-gray-700 text-sm font-semibold">
        <span className="border-b-2 border-red-600 pb-1">Living Room (3)</span>
        <span>Bedrooms (2)</span>
        <span>Others (10)</span>
        <span>Locality Photo (1)</span>
      </div>
    </div>
  );
};

export default FlatListingHeader;
